// webview updateHeader
export const addValueOption = [
  { value: 0, total: 0, show: 0, text: '不進行儲值優惠方案' },
  { value: 2000, total: 2080, show: 1800, text: '儲值 2000元，可折抵2080元消費' },
  { value: 5000, total: 5300, show: 4500, text: '儲值 5000元，可折抵5300元消費' },
  { value: 8000, total: 8800, show: 7200, text: '儲值 8000元，可折抵8800元消費' },
  { value: 10000, total: 11000, show: 9000, text: '儲值 10000元，可折抵11000元消費' },
  { value: 20000, total: 22000, show: 18000, text: '儲值 20000元，可折抵22000元消費' },
  { value: 30000, total: 33000, show: 27000, text: '儲值 30000元，可折抵33000元消費' },
  { value: 40000, total: 44000, show: 36000, text: '儲值 40000元，可折抵44000元消費' },
  { value: 50000, total: 55000, show: 45000, text: '儲值 50000元，可折抵55000元消費' },
  { value: 80000, total: 88000, show: 72000, text: '儲值 80000元，可折抵88000元消費' }
] as const
